export const departments = [
  {
    id: 0,
    name: 'General',
    links: [
      {
        url: 'https://www.duda.co/about',
        text: 'Learn about Duda'
      }
    ],
    address: false
  },
  {
    id: 1,
    name: 'QA',
    links: [
      {
        url: 'https://www.duda.co/about',
        text: 'Learn about Duda'
      }
    ],
    address: false
  },
  {
    id: 2,
    name: 'Finance',
    links: [
      {
        url: 'https://www.duda.co/about',
        text: 'Learn about Duda'
      }
    ],
    address: false
  },
  {
    id: 3,
    name: 'Marketing',
    links: [
      {
        url: 'https://resources.duda.co/success-stories',
        text: 'Read our success stories'
      }
    ],
    address: false
  },
  {
    id: 4,
    name: 'Business Development',
    links: [
      {
        url: 'https://resources.duda.co/success-stories',
        text: 'Read our success stories'
      }
    ],
    address: false
  },
  {
    id: 5,
    name: 'Sales',
    links: [
      {
        url: 'https://review.capterra.com/SS-Duda-134280',
        text: 'Leave us a review'
      },
      {
        url: 'https://www.duda.co/contact/schedule',
        text: 'Schedule a demo'
      }
    ],
    address: true
  },
  {
    id: 6,
    name: 'Customer Success',
    links: [
      {
        url: 'https://review.capterra.com/SS-Duda-134280',
        text: 'Leave us a review'
      },
      {
        url: 'https://help.duda.co/hc/en-us',
        text: 'Visit our Help Center'
      }
    ],
    address: false
  },
  {
    id: 7,
    name: 'HR',
    links: [
      {
        url: 'https://www.duda.co/careers',
        text: 'View our job openings'
      }
    ],
    address: false
  },
  {
    id: 8,
    name: 'Product',
    links: [
      {
        url: 'https://resources.duda.co/product-updates',
        text: 'View our product updates'
      }
    ],
    address: false
  },
  {
    id: 9,
    name: 'Development',
    links: [
      {
        url: 'https://resources.duda.co/product-updates',
        text: 'View our product updates'
      }
    ],
    address: false
  }
];
